import { render } from "./GatepassPrint.vue?vue&type=template&id=efea45c0&scoped=true"
import script from "./GatepassPrint.vue?vue&type=script&lang=js"
export * from "./GatepassPrint.vue?vue&type=script&lang=js"

import "./GatepassPrint.vue?vue&type=style&index=0&id=efea45c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efea45c0"]])

export default __exports__